import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Bootstrap JS (includes Popper) for dropdowns, tooltips, collapse, etc.
import 'bootstrap/dist/js/bootstrap.bundle.min';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
